import React from "react";
import ExploreProgram from "../Program/ExploreProgram";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LiveCourse from "./LiveCourse";

const Resources = () => {
   const { t } = useTranslation();
  return (
    <div className="mt-28 ml-5">
      <div className="text-sm mt-8">
        <Link to="/" className="text-gray-600 hover:text-blue-700">
          {t("Home")}
        </Link>
        <span className="text-gray-400"> &gt; </span>
        <span className="text-gray-800 font-medium">{t("Resources")}</span>
      </div>
      <LiveCourse/>
      <ExploreProgram />
    </div>
  );
};

export default Resources;